export const BLOCKCHAIN_TRANSACTIONS_TYPE_ENUM = {
    IN: 'in',
    OUT: 'out',
};